import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
// import ProjectAnimation from "./projectAnimations";
// import ProjectPage from "./project";
import Loader from "./loader";
// import MainContent from "./maincomponent";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <Loader /> */}
    {/* <MainContent /> */}
    {/* <ProjectPage /> */}
    <Router>
      <Loader />
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
